"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationMessagesStateFactory = exports.MESSAGE_TYPE = void 0;
var MESSAGE_TYPE;
(function (MESSAGE_TYPE) {
    MESSAGE_TYPE["ERROR"] = "ERROR";
    MESSAGE_TYPE["INFORMATION"] = "INFORMATION";
    MESSAGE_TYPE["SUCCESS"] = "SUCCESS";
    MESSAGE_TYPE["WARNING"] = "WARNING";
})(MESSAGE_TYPE = exports.MESSAGE_TYPE || (exports.MESSAGE_TYPE = {}));
var notificationMessagesStateFactory = function () { return []; };
exports.notificationMessagesStateFactory = notificationMessagesStateFactory;
